interface EnvironmentConfig {
    company: {
        name: string;
        longName: string;
        legalName: string;
    };
    contact: {
        email: string;
        phone: string;
    };
    address: {
        street: string;
        city: string;
        state: string;
        zip: string;
        full: string;
    };
    emails: {
        support: string;
        privacy: string;
        legal: string;
    };
}

// Helper function to get environment variables with defaults
const getEnvVar = (key: keyof ImportMetaEnv, defaultValue: string = ''): string => {
    return import.meta.env[key] || defaultValue;
};

export const ENV_CONFIG: EnvironmentConfig = {
    company: {
        name: getEnvVar('VITE_COMPANY_NAME', '4cast Labs'),
        longName: getEnvVar('VITE_COMPANY_LONG_NAME', '4CAST LABS'),
        legalName: getEnvVar('VITE_COMPANY_LEGAL_NAME', '4cast Labs, Inc.'),
    },
    contact: {
        email: getEnvVar('VITE_CONTACT_EMAIL', 'contact@4castlabs.com'),
        phone: getEnvVar('VITE_CONTACT_PHONE', '+1 (555) 123-4567'),
    },
    address: {
        street: getEnvVar('VITE_COMPANY_ADDRESS_STREET', '123 Innovation Drive'),
        city: getEnvVar('VITE_COMPANY_ADDRESS_CITY', 'Tech Park'),
        state: getEnvVar('VITE_COMPANY_ADDRESS_STATE', 'CA'),
        zip: getEnvVar('VITE_COMPANY_ADDRESS_ZIP', '94025'),
        full: '', // Will be computed below
    },
    emails: {
        support: getEnvVar('VITE_SUPPORT_EMAIL', 'support@4castlabs.com'),
        privacy: getEnvVar('VITE_PRIVACY_EMAIL', 'privacy@4castlabs.com'),
        legal: getEnvVar('VITE_LEGAL_EMAIL', 'legal@4castlabs.com'),
    },
};

// Compute the full address
ENV_CONFIG.address.full = `${ENV_CONFIG.address.street}, ${ENV_CONFIG.address.city}, ${ENV_CONFIG.address.state} ${ENV_CONFIG.address.zip}`;
